
import Vue from "vue";

import CheckbokCustom from "@/components/CheckbokCustom.vue";

export default Vue.extend({
  name: "FormInformationRvs",
  components: { CheckbokCustom },
  computed: {
    modelTypeId: {
      get(): number {
        return this.$store.getters.model.modelTypeId;
      },
    },
    items: {
      get(): { id: number; title: string }[] {
        return this.$store.state?.modelSettingForm?.configuration_information || [];
      },
    },
    selected: {
      get() {
        return this.$store.state?.updateModelForm?.configuration_in || [];
      },
      set(value: number[]) {
        this.$store.dispatch("setUpdateModelForm", {
          ...this.$store.state.updateModelForm,
          configuration_in: value,
        });
      },
    },
    isAutoSendRealTimeReport: {
      get(): boolean {
        return this.$store.state?.updateModelForm?.model_in.isRVSRealtimeReport;
      },
      set(value: boolean) {
        this.$store.dispatch("setUpdateModelForm", {
          ...this.$store.state.updateModelForm,
          model_in: {
            ...this.$store.state.updateModelForm.model_in,
            isRVSRealtimeReport: value,
          },
        });
      },
    },
  },
  mounted() {
    this.fetchEquipmentModel();
  },
  data() {
    return { isCheckAll: false };
  },
  methods: {
    handleAll(value: boolean) {
      this.selected = value ? this.items.map((item: { id: number; title: string }) => item.id) : [];
    },
    async fetchEquipmentModel() {
      try {
        const response = await Vue.prototype.$dep.modelUseCase.getModel(this.$route.params.id);
        this.isAutoSendRealTimeReport = response.isRVSRealtimeReport;
        if (response) {
          if (this.response?.items.length === 0) {
            return;
          }
        }
      } catch (err) {
        this.$swal({
          icon: "error",
          title: "Error",
          text: "An error occurred while loading. Please try again.",
          showConfirmButton: false,
          timer: 1500,
        });
        console.error("fetching error");
        console.error(err);
      }
    },
  },
  watch: {
    selected() {
      this.isCheckAll = this.selected.length === this.items.length;
    },
  },
});
